import React, { useCallback, useState } from 'react';
import IngredientsModal from './IngredientsModal';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { ResponseType } from 'business/models/Models';
import { saveProteinFormulationIngredientTypes } from 'business/services/IngredientService';
import useGetProteinTypeList from './hooks/useGetProteinTypeList';
import { IngredientsModalType } from './IngredientEnums';

const TYPES_COLUMNS = [
  {
    accessor: 'name',
    Header: 'Protein Type',
    editOptions: { inputType: 'text' },
  },
];

const AddProteinType = (props) => {
  const { showProteinTypeModal, setShowProteinTypeModal } = props;
  const [refetchCounter, setRefetchCounter] = useState(0);
  const proteinTypeList = useGetProteinTypeList(showProteinTypeModal, refetchCounter);

  const saveProteinTypesList = useCallback(async (allRows) => {
    const result = await saveProteinFormulationIngredientTypes(allRows);
    if (result.responseType == ResponseType.Success) {
      showAlertSnackBar(
        EAlertType.SUCCESS,
        ESnackBarPosition.TOP,
        'Protein Type has been updated successfully!',
      );
      return true;
    } else if (result.responseType == ResponseType.Warning) {
      showAlertSnackBar(EAlertType.WARNING, ESnackBarPosition.TOP, result.message);
      setRefetchCounter(refetchCounter + 1);
      return false;
    }
  }, []);

  return (
    <IngredientsModal
      id='addproteintype-wrapper'
      columns={TYPES_COLUMNS}
      saveModal={saveProteinTypesList}
      rowsData={proteinTypeList}
      showModal={showProteinTypeModal}
      setShowModal={setShowProteinTypeModal}
      dialogClassName={'w-[29.43%]'}
      heading="Protein Type"
      ingredientsModalType={IngredientsModalType.ProteinType}
    />
  );
};

export default AddProteinType;
